"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "albanella": {
    "fcb8229b": [{
      "hkey": "260c3334",
      "slug": "bosco-camerine",
      "name": "Bosco Camerine",
      "primary": true,
      "skipSearch": false
    }],
    "45226d5d": [{
      "hkey": "a9a5a49c",
      "slug": "albanella",
      "name": "Albanella",
      "primary": true,
      "skipSearch": false
    }],
    "san-chirico": [{
      "hkey": "a9a5a49c",
      "slug": "albanella",
      "name": "Albanella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bosco": [{
      "hkey": "260c3334",
      "slug": "bosco-camerine",
      "name": "Bosco Camerine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;